import { QueryFilters, useActiveResourcesFull, useActiveUsersFull } from '../../api';
import TopMetricsChart from '../../../../components/TopMetricsChart/TopMetricsChart';
import { EntityDetails, Timeframe, TopUsersAndResourcesTab } from '../../types';
import { useState } from 'react';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

const SEVEN_DAYS_TIMEFRAME: Timeframe = '7';

interface TopActiveChartProps {
    filters: QueryFilters;
    onInvestigationClick: (guid: string, adType: number) => void;
    activeUsers?: EntityDetails[];
    activeResources?: EntityDetails[];
    activeUsersIsLoading?: boolean;
    activeResourcesIsLoading?: boolean;
}

const TopActiveChart = ({
    filters,
    onInvestigationClick,
    activeUsers = [],
    activeResources = [],
    activeUsersIsLoading = false,
    activeResourcesIsLoading = false
}: TopActiveChartProps) => {
    const [topActiveSelectedTab, setTopActiveSelectedTab] = useState<TopUsersAndResourcesTab>('users');
    const [showMore, setShowMore] = useState(false);

    const { data: activeUsersFull = [], isLoading: activeUsersFullIsLoading } = useActiveUsersFull(filters, showMore);
    const { data: activeResourcesFull = [], isLoading: activeResourcesFullIsLoading } = useActiveResourcesFull(
        filters,
        showMore
    );

    const handleShowMore = () => {
        setShowMore(true);
    };

    const handleInvestigationClick = (guid: string, tabValue: string) => {
        const adType = tabValue === 'users' ? AD_ENTITY_TYPES.USER : AD_ENTITY_TYPES.SERVER;
        onInvestigationClick(guid, adType);
    };

    const timeframe = `last ${filters.timeframe} days`;

    return (
        <TopMetricsChart
            label="Top active"
            selectedTab={topActiveSelectedTab}
            onTabChange={(tab) => setTopActiveSelectedTab(tab)}
            onInvestigationClick={handleInvestigationClick}
            onShowMore={handleShowMore}
            tabs={[
                {
                    value: 'users',
                    name: 'Users',
                    previewData: activeUsers,
                    fullData: activeUsersFull,
                    previewLoading: activeUsersIsLoading,
                    fullLoading: activeUsersFullIsLoading,
                    disabled: activeUsers.length === 0,
                    emptyStateConfig: {
                        title: 'No users yet',
                        description: `No users have been active in the last ${timeframe}`
                    }
                },
                {
                    value: 'resources',
                    name: 'Resources',
                    previewData: activeResources,
                    fullData: activeResourcesFull,
                    previewLoading: activeResourcesIsLoading,
                    fullLoading: activeResourcesFullIsLoading,
                    disabled: activeResources.length === 0,
                    emptyStateConfig: {
                        title: 'No resources yet',
                        description: `No resources have been active in the last ${timeframe}`
                    }
                }
            ]}
        />
    );
};

export default TopActiveChart;
